import { render, staticRenderFns } from "./NvBookContent.vue?vue&type=template&id=080cefa4&scoped=true&"
import script from "./NvBookContent.vue?vue&type=script&lang=js&"
export * from "./NvBookContent.vue?vue&type=script&lang=js&"
import style0 from "./NvBookContent.vue?vue&type=style&index=0&id=080cefa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080cefa4",
  null
  
)

export default component.exports